import { createContext } from 'react';

import type { HistogramChartConfigProperties } from '../types/histogram-props.js';

/**
 * @internal
 */
export const HistogramChartConfigContext = createContext<
  HistogramChartConfigProperties | string
>({} as HistogramChartConfigProperties);

/**
 * Provider for the HistogramChart API config that can be shared across charts
 * @public
 */
export const HistogramChartConfig = HistogramChartConfigContext.Provider;
